module.exports = __webpack_public_path__ + "img/violet_079.3bd74c70.png";